const MutationTypes = {
  SET_USER_DATA: "SET_USER_DATA",
};

const initialState = {
  userData: {},
};

const state = { ...initialState };

const mutations = {
  [MutationTypes.SET_USER_DATA](state, data) {
    state.userData = data;
  },
};

const actions = {
  setUserData({ commit }, data) {
    commit(MutationTypes.SET_USER_DATA, data);
  },
};

const getters = {
  userData: (state) => state.userData,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
